import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';


import * as commercialActions from 'redux/modules/commercial';

import { CommercialForm } from 'components';


import { initializeWithKey } from 'redux-form';
import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';
var _ = require('underscore');

import { Col, OverlayTrigger, Tooltip, Button } from 'react-bootstrap';


import { ReloadButton } from 'components';
import { translate } from 'react-i18next';

@translate(['common'])
@asyncConnect([{
  promise: ({ store: { dispatch, getState }, params }) => {
    const promises = [];
    promises.push(dispatch(commercialActions.load(params)));
    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    commercials: state.commercial.data,
    editing: state.commercial.editing,
    error: state.commercial.error,
    loading: state.commercial.loading,
    editMode: state.commercial.editMode
  }),
  { ...commercialActions, initializeWithKey })

export default class CommercialList extends Component {



  componentDidMount() {
  	/*
  	this.props.dispatch(productActions.clearProducts());
  	this.props.dispatch(ficheActions.clearFiches());
  	this.props.dispatch(groupActions.clearGroups());
  	this.props.dispatch(userActions.clear());
  	this.props.dispatch(ticketActions.clearTickets());
  	this.props.dispatch(supervisionActions.unmount());*/

  }

  render() {

    const {
      commercials,
      error,
      editing,
      loading,
      load,
      sending,
      dispatch,
      params,
      editMode,
      t
    } = this.props;


    let refreshClassName = 'fa fa-refresh';
    let refreshSCC = 'fa fa-refresh';

    if (loading) {
      refreshClassName += ' fa-spin';
    }

    const styles = require('./Clients.scss');

    var commercial_rows = [];

    for (var id in commercials) {

      var commercial = commercials[id];


      const handleEdit = (commercial) => {
        const { editStart } = this.props; // eslint-disable-line no-shadow
        return () => editStart(String(commercial.id));
      };

      const handleDelete = (username) => {
        const { deleteCommercial } = this.props; // eslint-disable-line no-shadow
        return () => deleteCommercial(String(username));
      };




      var form = (
        <div>
          <CommercialForm formKey={String(commercial.id)}
            key={String(commercial.id)} action='update'
            initialValues={commercial}
            commercial={commercial}
          />


        </div>
      );

      var textSend = '';

      try {
        if (sending[commercial.id].loading == true) {
          refreshSCC += ' fa-spin';
          var disabled = true;
        } else {
          refreshSCC = 'fa fa-refresh';
          var disabled = false;
        }

        if (sending[commercial.id].loaded == true) {

          refreshSCC += ' fa-thumbs-up';
          var sendStyleBtn = 'btn-success';
          //var textSend = 'Identifiants renvoyés';
        }

      } catch (e) {
        refreshSCC = 'fa fa-refresh';
        var disabled = false;
        var sendStyleBtn = '';

        //var textSend = 'Renvoyer les identifiants';
      }


      var actionTD =
        <td style={{ width: '50px' }}>
          <div >
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">
              <strong>Editer le commercial</strong>
            </Tooltip>}>
              <Button bsStyle='primary' bsSize="sm" onClick={handleEdit(commercial)}>
                <i className="fa fa-pencil" />
              </Button>
            </OverlayTrigger>

            {/*
          &nbsp;
          
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">
            <strong>Renvoyer les identifiants</strong>
            </Tooltip>}>
            <Button disabled={disabled} bsSize="sm" className={sendStyleBtn} 
              onClick={handleSendCredentials(commercial)}>
            
              <i className={refreshSCC}/> {textSend}
            </Button> 
          </OverlayTrigger>
          */}
          </div>


        </td>



      var tds = [
        actionTD,
        <td>{commercial.login}-com</td>,
        <td>{commercial.email}</td>,
      ]


      var tr = (
        <tr key={commercial.id}>
          {tds}
        </tr>

      );

      commercial_rows.push(tr)

      var content;

      if (editing[commercial.id] == true) {
        content = form;

        break
      } else {

        if (commercials) {
          content = (

            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Actions</th>
                    <th>Login</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  {commercial_rows}
                </tbody>
              </table>
            </div>
          )

        }


      }


    }

    return (
      <div className={styles.commercials + ' container'}>
        <h1>
          Commercials &nbsp;
          {!editMode &&
            <ReloadButton module={t("main.commercials")} submit={() => dispatch(commercialActions.load(this.props.params))} loading={loading} />
          }
        </h1>
        <Helmet title="Commercials" />
        {content}

        {error &&

          <Col md={3} >
            <div className="alert alert-danger" role="alert">
              <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              {' Erreur de connexion'}
            </div>
          </Col>}

      </div>
    );
  }
}

